const NONE = 'none'
const SPECIFIC_TEXT = 'specific-text'
const DATA_SOURCE = 'data-source'
const SPECIFIC_FIELD = 'specific-field'

export { NONE, SPECIFIC_TEXT, DATA_SOURCE, SPECIFIC_FIELD }
